module.exports = __webpack_public_path__ + "static/media/cloud-a-v3.e970a44b.svg";